<div class="slide" [class.large]="large()" [style.background-color]="bgColor()">
  <div class="content">
    @if (newTile()) {
      <div class="new">New</div>
    }
    @if (htmlContent()) {
      <div class="description" [innerHTML]="safeHTML!"></div>
    }
  </div>
  @if (imageSrc()) {
    <div class="image">
      <app-image [src]="imageSrc()" [imageCover]="true" />
    </div>
  }
</div>